// services/StaffProfileService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getStaffProfiles(params = {}) {
    return api.get(ENDPOINTS.STAFF_PROFILES.BASE, { params });
}
export function getStaffProfileById(id) {
    return api.get(ENDPOINTS.STAFF_PROFILES.BY_ID(id));
}
export function createStaffProfile(payload) {
    return api.post(ENDPOINTS.STAFF_PROFILES.BASE, payload);
}
export function updateStaffProfile(id, payload) {
    return api.patch(ENDPOINTS.STAFF_PROFILES.BY_ID(id), payload);
}
export function deleteStaffProfile(id) {
    return api.delete(ENDPOINTS.STAFF_PROFILES.BY_ID(id));
}
export function restoreStaffProfile(id) {
    return api.post(`${ENDPOINTS.STAFF_PROFILES.BY_ID(id)}/restore`);
}
